export function formatLettersFirstUpper(str: string): string {
    if(!str) return ''
    const answer = str[0].toUpperCase() + str.slice(1)
    return answer.replace(/[^a-zA-Zа-яА-Я]/g, '');
}